import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";

import "./sectionToggle.scss";

const SectionToggle = ({
  autoHeight,
  height = 550,
  maxHeight = 5000,
  paddingBottom = 0,
  isLoading,
  sectionToggled,
  title,
  customClass = "",
  ctaLink,
  showCta,
  ctaContent,
  learnMore,
  hideToggle,
  content,
  renderAI
}) => {
  const minHeight = 500;
  const [checked, setChecked] = useState(true);
  const [heightState, setHeightState] = useState(autoHeight ? "auto" : height);
  const contentRef = useRef();
  let baseHeight = 0;

  useEffect(() => {
    if (autoHeight) {
      setHeightState("none");
    }
  }, []);

  useEffect(() => {
    if (autoHeight || isLoading) {
      return;
    }
    if (contentRef.current.offsetHeight > 0 && baseHeight !== contentRef.current.offsetHeight) {
      baseHeight = Math.max(baseHeight, contentRef.current.offsetHeight, heightState);

      if (heightState < baseHeight) {
        setHeightState(baseHeight);
      }
    }
  }, [heightState, contentRef.current]);

  const handleChange = () => {
    sectionToggled && sectionToggled(!checked);
    setChecked(!checked);
  };

  return (
    <div data-testid={title} className={"react-section-wrapper " + customClass}>
      <div className="section-inner">
        <div className="react-section-title">
          <span className="text" data-testid="title">
            {title}
            {showCta ? (
              <a className="cta" href={ctaLink} data-testid="cta">
                {ctaContent}
              </a>
            ) : null}
          </span>
          <div className="learn" data-testid="learn-more">
            {learnMore}
          </div>

          {!hideToggle ? (
            <div className="sectionToggle" onClick={handleChange} data-testid="toggle">
              <svg
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`angleIcon ${checked ? "" : "angleIcon--flipped"}`}
              >
                <path
                  d="M1 6.00002L6.00002 1L11 6.00002"
                  stroke="white"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          ) : null}
        </div>
        <div
          className="section-content"
          style={{
            maxHeight,
            minHeight: heightState,
            paddingBottom,
            display: checked ? " flex" : "none"
          }}
          data-testid="content-container"
        >
          <div
            className="sectionContentInner section-content-inner"
            ref={contentRef}
            style={{ maxHeight, minHeight: heightState }}
            data-testid="content"
          >
            {renderAI && renderAI()}

            {isLoading ? (
              <LoadingAnimation height={autoHeight ? minHeight : heightState} />
            ) : (
              content
            )}
            <div className="clear-fix" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionToggle;

SectionToggle.propTypes = {
  title: PropTypes.string,
  content: PropTypes.any,
  customClass: PropTypes.string,
  showCta: PropTypes.bool,
  ctaLink: PropTypes.string,
  ctaContent: PropTypes.string,
  sectionToggled: PropTypes.func,
  hideToggle: PropTypes.bool,
  learnMore: PropTypes.any,
  autoHeight: PropTypes.bool,
  isLoading: PropTypes.bool,
  height: PropTypes.number,
  maxHeight: PropTypes.any,
  paddingBottom: PropTypes.number
};
